import { Direction } from "../i18n/LocaleContext"

/**
 * Flex direction.
 *
 * Similar to css `flex-direction`.
 */
const flexDirections = ["row", "column", "row-reverse", "column-reverse"]
export type FlexDirection = (typeof flexDirections)[number]

export const isFlexDirection = (x: any): x is FlexDirection =>  flexDirections.includes(x)

/**
 * Fixed direction.
 *
 * Lays out children in specific left-to-right or right-to-left order ignoring locale direction.
 * Intended to be used when representing physical layouts.
 */
const fixedDirections = ["row-ltr", "row-rtl"]
export type FixedDirection = (typeof fixedDirections)[number]

export const isFixedDirection = (x: any): x is FixedDirection =>  fixedDirections.includes(x)

/**
 * For use when layouts support either flex or fixed layouts.
 */
export type LayoutDirection = FlexDirection | FixedDirection
export const isLayoutDirection = (x: any): x is LayoutDirection =>
  (isFlexDirection(x) || isFixedDirection(x))

export function getCssFlexDirection(
  layoutDirection: LayoutDirection,
  localeDirection: Direction
): FlexDirection {
    if (isFlexDirection(layoutDirection)) {
      return layoutDirection
    }

    if (layoutDirection === "row-ltr") {
      return (localeDirection === "ltr") ? "row" : "row-reverse"
    } else {
      return (localeDirection === "ltr") ? "row-reverse" : "row"
    }
}
